<template>
  <div id="app">
    <Header />
    <Info />
    <Videos />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Videos from "./components/Videos.vue";
import Footer from "./components/Footer";
import Info from "./components/Info";

export default {
  name: "App",
  components: {
    Header,
    Videos,
    Footer,
    Info
  },
  data() {
    return {};
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #e2e8f0;
}
body {
  margin: 0px;
}

.container {
  text-align: center;
}
</style>
